import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KennethMustDie} from "../KennethMustDie";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {KMDSound} from "../sound/KMDSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";

export class KMDMgIntro extends PIXI.Container implements StageLayer {
    private _tl: gsap.core.Timeline | null;
    private _prevSpaceBarSettings: boolean; // #329
    private _stopped: boolean;

    constructor() {
        super();
        this.name = "KMDMgIntro";

        this._prevSpaceBarSettings = false;
    }

    public play(): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.1
            }),
            item: PIXI.spine.Spine = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("mgIntroBeefy")),
            textItem: PIXI.Text = new PIXI.Text(' "EVERYONE SHOULD BE ABLE TO LOVE WHO EVER THEY WANT" ', // we don't want to translate it, #482
                new PIXI.TextStyle({
                    fontSize: 28,
                    fontFamily: OpenSans.FAMILY,
                    fill: "#ffc900"
                })),
            textMask: PIXI.Graphics = new PIXI.Graphics();

        textMask.beginFill(0xffffff, 1);
        textMask.drawRect(0, 650, 720, 32);
        textMask.endFill();

        textItem.position.set(720, 650);
        textItem.mask = textMask;

        this._stopped = false;

        item.visible = false;
        item.position.set(360);

        // #329
        this._prevSpaceBarSettings = KennethMustDie.apiPlugin.settings.get(APISetting.USE_SPACE_TO_SPIN, false);
        KennethMustDie.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, false);

        this.addChild(item, textMask, textItem);

        // #277
        KennethMustDie.blackBg.interactive = true;
        KennethMustDie.blackBg.buttonMode = true;
        KennethMustDie.blackBg.once('pointerdown', () => {
            this.stopIntro();
        });
        KennethMustDie.keypadPlugin.toggleVisibility(false);

        tl.add([
            () => {
                item.visible = true;
                KennethMustDie.blackBg.show(0.8);

                // #248
                KennethMustDie.soundPlayer.playSound(KMDSound.BEEFY_INTRO);
            },
            KennethMustDie.createTimelineForAnimation(item, 0, "animation", false).repeat(2)
        ]);

        tl.to(textItem, {
            duration: tl.totalDuration() - 0.2,
            x: -830,
            ease: "none"
        }, 0.2);

        tl.add(() => {
            KennethMustDie.blackBg.hide(0.5);

            // #277
            KennethMustDie.blackBg.interactive = false;
            KennethMustDie.blackBg.buttonMode = false;
        });
        tl.to([item, textItem], {
            duration: 0.5,
            alpha: 0
        });
        tl.add(() => {
            item.destroy();
            textItem.destroy();
            NolimitApplication.removeLayer(this.name);

            // #277
            KennethMustDie.keypadPlugin.toggleVisibility(true);
        });

        this._tl = tl;
    }

    public stopIntro(): void {
        if (this._stopped) {
            return;
        }

        if (this._tl && this._tl.isActive()) {
            this._tl.totalProgress(1);

            // #248
            KennethMustDie.soundPlayer.stopSound(KMDSound.BEEFY_INTRO);

            KennethMustDie.keypadPlugin.toggleVisibility(true);

            this._tl = null;
        }

        // #277
        KennethMustDie.blackBg.interactive = false;
        KennethMustDie.blackBg.buttonMode = false;

        // #329
        KennethMustDie.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, this._prevSpaceBarSettings);

        this._stopped = true;
    }
}